import React, { Component } from 'react'
import { Media } from 'reactstrap'
import {
  Button,
  Footer as FooterComponent,
} from './common'
import { withRouter } from 'react-router-dom'

const styles = {
  container: {
    backgroundColor: '#562A31',
    height: 450,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 75,
    paddingTop: 50,
    paddingBottom: 0,
  },
  topWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    maxWidth: 1200,
    flex: 1.6,
  },
  divider: {
    borderBottomWidth: 1,
    borderBottomStyle: 'solid',
    borderBottomColor: '#EDE8E4',
    width: '100%',
    maxWidth: 1200,
  },
  footerComp: {
    container: {
      flex: 3,
      backgroundColor: '#562A31',
      minWidth: 650,
    },
    defaultColumn: {
      margin: 0,
      padding: 0,
    },
    defaultHeader: {
      color: '#E86956',
      fontSize: 35,
      fontFamily: 'capitolina, serif',
      fontStyle: 'italic',
    },
    defaultText: {
      fontSize: 16,
      color: '#EDE8E4',
      marginBottom: 10,
    },
    defaultLink: {
      fontSize: 16,
      color: '#EDE8E4',
      marginBottom: 10,
      display: 'block',
      cursor: 'pointer',
    },
    columns: [{}, {}, {}, {}],
  },
  buttonWrapper: {
    flex: 1,
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-start',
  },
  button: {
    height: 80,
    width: 80,
    position: 'relative',
    borderWidth: 2,
    borderColor: '#EDE8E4',
    borderStyle: 'solid',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    filter: 'none',
    hovered: {
      backgroundColor: 'rgba(0,0,0,0)',
      borderColor: '#EDE8E4',
      filter:
        'invert(57%) sepia(14%) saturate(4670%) hue-rotate(325deg) brightness(95%) contrast(91%)',
    },
  },
  buttonImg: {
    height: 45,
    width: 45,
    paddingBottom: 5,
  },
  bottomWrapper: {
    width: '100%',
    maxWidth: 1200,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flex: 1,
    paddingTop: 15,
  },
  copyright: {
    color: '#EDE8E4',
    fontSize: 18,
    marginRight: 25,
    fontFamily: 'acumin-pro-condensed, sans-serif',
    letterSpacing: 1.25,
  },
  socialWrapper: {
    width: 250,
    height: 50,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  socials: {
    paddingLeft: 35,
  },
  socialImages: {
    height: 25,
    width: 25,
  },
  upArrow: {
    borderStyle: 'solid',
    borderColor: '#EDE8E4',
    borderWidth: '0 2px 2px 0',
    display: 'inline-block',
    padding: 15,
    marginTop: 15,
    transform: 'rotate(-135deg)',
  },
}

class FooterDesktop extends Component {
  constructor(props) {
    super(props)

    this.state = {
      intervalId: 0,
      hovered: false,
      activeIndex: null,
    }

    this.handleScroll = this.handleScroll.bind(this)
    this.scrollStep = this.scrollStep.bind(this)
  }

  scrollStep() {
    const { intervalId } = this.state
    if (window.pageYOffset === 0) {
      clearInterval(intervalId)
    }
    window.scroll(0, window.pageYOffset - 100)
  }

  handleScroll() {
    const { scrollStep } = this
    let intervalId = setInterval(scrollStep, 0)
    this.setState({
      intervalId: intervalId,
    })
  }
  hoverImg = (index = null) => {
    this.setState({
      hovered: true,
      activeIndex: index,
    })
  }
  leaveHoverImg = (index = null) => {
    this.setState({
      hovered: false,
      activeIndex: null,
    })
  }
  render() {
    const { handleScroll, hoverImg, leaveHoverImg } = this
    const { hovered, activeIndex } = this.state
    const { columns, copyright, socials, history } = this.props

    return (
      <div style={styles.container}>
        <div style={styles.topWrapper}>
          <FooterComponent columns={columns} styles={styles.footerComp} useRouter={true} history={history} />
          <div style={styles.buttonWrapper}>
            <Button onClick={handleScroll} styles={styles.button}>
              <i style={styles.upArrow} />
            </Button>
          </div>
        </div>
        <div style={styles.divider}></div>
        <div style={styles.bottomWrapper}>
          <div style={styles.copyright}>{copyright}</div>
          <div style={styles.socialWrapper}>
            {socials.map((s, index) => {
              return (
                <div key={index} style={styles.socials}>
                  <a href={s.url}>
                    <Media
                      onMouseEnter={() => hoverImg(index)}
                      onMouseLeave={() => leaveHoverImg(index)}
                      object
                      src={s.icon}
                      alt={s.name}
                      style={{
                        ...styles.socialImages,
                        filter:
                          hovered && activeIndex === index
                            ? 'invert(57%) sepia(14%) saturate(4670%) hue-rotate(325deg) brightness(95%) contrast(91%)'
                            : 'none',
                      }}
                    />
                  </a>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(FooterDesktop)
